import { atom } from 'recoil';

const transactionsState = atom({
  key: 'transactionsState',
  default: [],
});

export { transactionsState };
